module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-col', [_c('v-ons-row', {
    staticClass: "color-chart-text"
  }, [_c('v-ons-col', {
    style: (_vm.minColor)
  }, [_vm._v("低い")]), _vm._v(" "), _c('v-ons-col', {
    style: (_vm.maxColor)
  }, [_vm._v("高い")])], 1), _vm._v(" "), _c('v-ons-row', {
    staticClass: "color-chart"
  }, _vm._l((_vm.colors), function(color) {
    return _c('v-ons-col', {
      key: color,
      staticClass: "color",
      style: ({
        background: color
      })
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52bf9ac2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/color_chart/temperature.vue
// module id = 821
// module chunks = 0